<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
export default {
  components: {ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Account Ledger List",
      items: [
        {
          text: "Account Ledger",
          href: "/",
        },
        {
          text: "Account Ledger List",
          active: true,
        },
      ],
      errors: null,
        display_div:true,
      vendors: [],
        user_type:"",
      admins: [],
        alladmins:[],
        transaction_types:[],
        transaction_type_id:"",
      pin: "",
      ledgers: [],
      user_id: "",
      crBalance: 0.0,
      drBalance: 0.0,
      totalBalance: 0.0,
        startBalance:0.0,
        endBalance:0.0,
      runningBal: [],
      startdate: "",
      enddate: "",
      remarks: "",
        visible:false,
        message:"",
    };
  },
    created() {
        this.user_id=this.$route.params.user_id;
    },
  mounted() {
      if(this.user_id != undefined){
          this.getUserID();
          this.display_div=false;
      }
    this.getAdminList();
    this.transactionTypeList();
      this.search();
  },
    watch: {
        $route(to, from) {
            this.user_id = this.$route.params.id;
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
      async getUserID() {
          try {
              axios
                  .post("/api/get-user-id/" + this.user_id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.status) {
                          this.user_id=parseInt(response.data);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c'){
                                  if(temp[i].first_name==null){
                                      temp[i].text=temp[i].email + '(unregistered)';
                                  }else{
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  }
                                  temp[i].value = temp[i].id;
                                  arr.push(temp[i]);
                              }

                          }
                          this.alladmins=arr;
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async transactionTypeList() {
          try {
              axios
                  .get("/api/ledger/transaction-types", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.status == 200) {
                          this.transaction_types = response.data.data;
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    async search() {
          console.log(this.user_id);
      try {
        axios
          .get("/api/ledger/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              user_id: this.user_id,
              startdate: this.startdate,
              enddate: this.enddate,
                transaction_type_id:this.transaction_type_id,
                user_type:this.user_type
            },
          })
          .then((response) => {
            if (response.data.status) {
              var list = [];
              var crBal = 0;
              var drVal = 0;
              var rowVal = 0;
              var totalVal = 0;
              var that = this;
              that.crBalance=0;
              that.drBalance=0;

              response.data.data.map(function (value, key) {
                  if(key==0){
                      that.endBalance=value.available_balance;
                  }
                  that.startBalance=value.available_balance;
                rowVal = 0;
                rowVal =
                  parseFloat(value.debit_balance) -
                  parseFloat(value.credit_balance);

                totalVal = parseFloat(totalVal) + parseFloat(rowVal);

                that.runningBal[key] = parseFloat(totalVal).toFixed(2);

                that.crBalance = parseFloat(
                  parseFloat(that.crBalance) + parseFloat(value.credit_balance)
                ).toFixed(2);

                that.drBalance = parseFloat(
                  parseFloat(that.drBalance) + parseFloat(value.debit_balance)
                ).toFixed(2);
              });

              this.ledgers = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async clear() {
          this.user_type="";
              this.startdate="";
              this.enddate="";
              this.transaction_type_id="";
              this.user_id="";
          this.admins=this.alladmins;
      },
      onChange(event) {
          this.user_type=event.target.value;
          var temp=this.alladmins;
          var arr=[];
          var i;
          for (i=0;i<temp.length;i++){
              if (temp[i].account_type==event.target.value){
                  arr.push(temp[i]);
              }
          }
          this.admins = arr;
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.$swal("Error", obj.message, "error");
        this.search();
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
              <h4 class="card-title">Account Ledger List</h4>
            <div v-if="display_div" class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="user_type">Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            @change="onChange($event)"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Select User</label>
                    <model-select :options="admins"
                                  v-model="user_id"
                                  placeholder="Select User">
                    </model-select>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="start-datepicker-1">Start Date</label>
                  <b-form-datepicker id="start-datepicker" v-model="startdate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label for="end-datepicker">End Date</label>
                  <b-form-datepicker id="end-datepicker" v-model="enddate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="type_id">Transaction Type</label>
                        <select
                            id="type_id"
                            name="type_id"
                            v-model="transaction_type_id"
                            class="form-control"
                            placeholder="Type Select User">
                            <option v-for="(transaction_type, index) in transaction_types" :value="transaction_type.id"
                                    v-bind:key="index">{{ transaction_type.type_name }}
                            </option>
                        </select>
                    </div>
                </div>
              <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <div class="row">
                  <h4 class="card-title margin-30per">Transaction List</h4>
                  <div class="col-2">
                      <div>
                          <p class="mb-2">Starting Balance</p>
                          <h5>{{startBalance}}</h5>
                      </div>
                  </div>
                  <div class="col-2">
                      <div>
                          <p class="mb-2">Ending Balance</p>
                          <h5>{{endBalance}}</h5>
                      </div>
                  </div>
              </div>


            <div class="table-responsive">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                      <th>User/Agency</th>

                      <th>Date</th>
                      <th>
                      <div>Transaction Type/</div>
                      <div>Remarks</div>
                      </th>
                      <th>Created By</th>
                      <th>
                          <div>Currency/</div>
                          <div>Attachment</div>
                      </th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Current Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ledger,index) in ledgers"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="ledger.username!=null">
                          <div v-if="ledger.account_type==='b2b'" class="row">
                              <div v-if="ledger.username!=null" class="col-xs-4">{{ledger.user_name}}</div>
                          </div>
                          <div v-if="ledger.account_type==='b2c'" class="row">
                              <div v-if="ledger.username!=null" class="col-xs-4">{{ledger.user_name+"("+ledger.account_type+")"}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"><router-link  :to="{ name: 'admin_agent_details', params: {id: ledger.user_id } }" target="_blank" >{{ledger.username==null ? 'N/A' : ledger.username}}</router-link></div>
                          </div>
                          <div v-if="ledger.account_type==='b2b'" class="row">
                              <div v-if="ledger.agency_name!=null" class="col-xs-4">{{ledger.agency_name}}</div>
                          </div>
                      </td>
                      <td v-else>N/A</td>

                      <td>{{ledger.created_at | moment("D MMM YYYY, H:mm")}}</td>

                      <td>
                          <div>{{ledger.transaction_type.type_name}}</div>
                            <div>{{ledger.remarks}}</div>
                      </td>
                      <td>
                          <div>{{ledger.created_by==null ? 'N/A' : ledger.created_by}}</div>
                          <div>{{ledger.created_by_type}}</div>
                      </td>
                      <td>
                          <div>{{ledger.currency}}</div>
                      <div  v-if="ledger.attachment_url!=null" >
                          <a :href="ledger.attachment_url" download target="_blank">Download Attach.</a>
                      </div>
                      </td>

                    <td>{{ledger.debit_balance == 0 ? '-':ledger.debit_balance}}</td>
                    <td>{{ledger.credit_balance == 0 ? '-':ledger.credit_balance }}</td>
                    <td>{{ledger.available_balance}}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="7"></th>
                    <th>Total = {{drBalance}}</th>
                    <th>Total = {{crBalance}}</th>
<!--                    <th>Total = {{drBalance-crBalance}}</th>-->
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
#start-datepicker__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
.margin-30per{
    margin-right: 30%;
}
</style>
